import api from './api';

export const emailPreviewService = {
    /**
     * @returns {Promise<{ events: { key: string, required: boolean,
     *           roles: string[] }[] }>}
     */
    async listEvents() {
        const response = await api.get('/admin/email-previews');
        return response.data;
    },

    /**
     * Render one catalog event as one role would receive it. Nothing is sent.
     *
     * @returns {Promise<{ event: string, role: string, required: boolean,
     *           subject: string, text: string, html: string, link: string }>}
     */
    async getPreview(eventKey, role) {
        const response = await api.get(
            `/admin/email-previews/${encodeURIComponent(eventKey)}`,
            { params: role ? { role } : undefined }
        );
        return response.data;
    },
};

export default emailPreviewService;
